import { css } from "@emotion/css"

type Props = {
  children: React.ReactNode
  disabled?: boolean
}

const VisuallyHidden = ({ children, disabled = false }: Props) => {
  return <span className={disabled ? undefined : style}>{children}</span>
}

export default VisuallyHidden

const style = css`
  &,
  * {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0px !important;
    margin: 0px !important;
    overflow: hidden !important;
    clip: rect(1px, 1px, 1px, 1px) !important;
    border: none !important;
    opacity: 0 !important;
  }
`
